import { ComponentType } from 'react';
import * as S from './styles';
import { IconProps } from '@/types/icon';
import { useTheme } from 'styled-components';

export type MenuItemVariant = 'solid' | 'soft';

export type MenuItemState = 'selected' | 'default';

export type MenuItemProps = {
  $variant: MenuItemVariant;
  $state: MenuItemState;
  $text: string;
  Icon: ComponentType<IconProps>;
};

export default function MenuItem(props: MenuItemProps) {
  const theme = useTheme();
  const { Icon, $state, $text, $variant } = props;
  const propsStyle = { $variant, $state };
  return (
    <S.Container {...propsStyle}>
      <Icon
        size={theme.typography.font.size['3']}
        color={
          $state === 'default'
            ? theme.tokens.colors.text
            : theme.colors.accent_contrast
        }
      />
      <S.Texto {...propsStyle}>{$text}</S.Texto>
    </S.Container>
  );
}
